<template>
  <div>
    <el-table
      v-loading="loading"
      :data="tableList"
      border
      class="table"
      header-row-class-name="header"
      highlight-current-row
      style="width: 100%;"
    >
      <!-- 序号列 -->
      <el-table-column :index="indexMethod" align="center" label="序号" type="index" width="55"/>

      <!-- 原图列 -->
      <el-table-column align="center" label="原图" width="120">
        <template slot-scope="{ row }">
          <el-image
            :preview-src-list="[row.imgUrl]"
            :src="row.imgUrl"
            alt="原图"
            fit="cover"
            height="50"
            width="50"
          />
        </template>
      </el-table-column>

      <!-- 动态生成的列（根据 orderStatus 动态控制显示的字段） -->
      <el-table-column
        v-for="(item, index) in (orderStatus === 0 ? tableDataPending : tableDataProcessed)"
        :key="index"
        :label="item.text"
        :prop="item.value"
        align="center"
      >
        <template slot-scope="{ row }">
          <!-- 处理淘宝订单号的展示和复制 -->
          <span v-if="item.value === 'inquiryId'">
            <el-tooltip content="复制询价单号" placement="top">
              <span v-if="row.inquiryId" class="copy" @click="copyTaobaoInquiryId(row.inquiryId)">
                {{ row.inquiryId }}
                <el-button icon="el-icon-document-copy" type="text"/>
              </span>
              <span v-else>-</span>
            </el-tooltip>
          </span>
          <span v-else-if="item.value === 'tbOrderId'">
            <el-tooltip content="复制淘宝订单号" placement="top">
              <span v-if="row.tbOrderId" class="copy" @click="copyTaobaoOrderId(row.tbOrderId)">
                {{ row.tbOrderId }}
                <el-button icon="el-icon-document-copy" type="text"/>
              </span>
              <span v-else>-</span>
            </el-tooltip>
          </span>
          <span v-else-if="item.value === 'isOrdered'">
            <span v-if="row.isOrdered === 1">是</span>
            <span v-if="row.isOrdered === 0" style="color: red;">否</span>
          </span>
          <span v-else-if="item.value === 'orderId'">
            <el-tooltip content="复制订单号" placement="top">
              <span v-if="row.orderId" class="copy" @click="copyOrderId(row.orderId)">
                {{ row.orderId }}
                <el-button icon="el-icon-document-copy" type="text"/>
              </span>
              <span v-else>-</span>
            </el-tooltip>
          </span>

          <!-- 处理不同字段的展示 -->
          <span v-else-if="item.value === 'cinemaInfo'">
            <!-- 影院信息 -->
            <div>影院: {{ row.cinemaName }}</div>
            <div>城市: {{ row.cityName }}</div>
            <div>影厅: {{ row.hallName }}</div>
            <div>座位: {{ row.seat }}</div>
          </span>
          <span v-else-if="item.value === 'movieInfo'">
            <!-- 影片信息 -->
            <div>影片: {{ row.movieName }}</div>
            <div>场次: {{ row.showTimeStr }}</div>
            <div>是否可调座: {{ row.acceptChangeSeat ? '是' : '否' }}</div>
          </span>
          <span v-else-if="item.value === 'statusDesc'">
						状态：
						{{
              row.statusDesc
            }}<br/>
						{{ row.status === 4 ? `关闭理由：${row.closeRemark}` : '' }}
					</span>
          <span v-else-if="item.value === 'advicePrice'">
            <!-- 订单金额 -->
            <div> {{ (row.advicePrice / 100).toFixed(2) }} 元</div>
          </span>
          <span v-else-if="item.value === 'operator'">
            <!-- 订单金额 -->
            <div> 处理人：{{ row.operator }} <br>
								处理时间：{{ row.operatorTime }}
						</div>
          </span>
          <span v-else>
            <!-- 其他字段 -->
            {{ row[item.value] }}
          </span>
        </template>
      </el-table-column>

      <!-- 操作列（仅待处理状态显示操作按钮）-->
      <el-table-column v-if="orderStatus === 0" align="center" fixed="right" label="操作">
        <template slot-scope="{ row }">
          <span class="look" @click="openDialog(row)">{{row.isOrdered ? '纠错下单' : '纠错报价' }}</span>
          <span class="delete" @click="openRemoveDialog(row)">移除</span>
        </template>
      </el-table-column>
    </el-table>

    <taobao-order-error-dialog
      :formData="currentFormData"
      :visible.sync="dialogVisible"
      @refreshData="refreshTableData"
    />

    <!-- 引入并使用移除订单弹窗 -->
    <taobao-order-error-remove-dialog
      :id="selectedOrder ? selectedOrder.id : ''"
      :visible.sync="removeDialogVisible"
      @confirm-remove="handleRemoveOrder"
      @remove-success="refreshTableData"
      @refresh-data="refreshTableData"
    />
  </div>
</template>

<script>
import TaobaoOrderErrorDialog from './taobaoOrderErrorDialog.vue'; // 引入人工纠错弹窗组件
import TaobaoOrderErrorRemoveDialog from './taobaoOrderErrorRemoveDialog.vue'; // 引入移除订单弹窗组件

export default {
  components: {
    TaobaoOrderErrorDialog,
    TaobaoOrderErrorRemoveDialog,
  },
  props: {
    // 接收外部传入的 tableList 数据
    tableList: {
      type: Array,
      required: true
    },
    // 外部传入的 loading 状态
    loading: {
      type: Boolean,
      default: false
    },
    // 传入的订单状态，0 为待处理，1 为已处理
    orderStatus: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      dialogVisibleIsOrdered:false,
      dialogVisible: false, // 控制人工纠错弹窗的可见性
      removeDialogVisible: false, // 控制移除订单弹窗的可见性
      currentFormData: {},  // 当前选中的表单数据
      selectedOrder: null,  // 当前选中的移除订单
      // 待处理状态下的表格字段
      tableDataPending: [
        {text: '店铺名称', value: 'tbShopName'},
        {text: '是否下单', value: 'isOrdered'},
        {text: '旺旺对接客服', value: 'serviceNickName'},
        {text: '下单用户', value: 'userNickName'},
        {text: '询价单号', value: 'inquiryId'},
        {text: '添加时间', value: 'createTimeStr'},
      ],
      // 已处理状态下的表格字段
      tableDataProcessed: [
        {text: '影院信息', value: 'cinemaInfo'},
        {text: '影片信息', value: 'movieInfo'},
        {text: '订单报价金额', value: 'advicePrice'},
        {text: '淘宝订单号', value: 'tbOrderId'},
        {text: '是否下单', value: 'isOrdered'},
        {text: '淘宝店铺名称', value: 'tbShopName'},
        {text: '旺旺对接客服', value: 'serviceNickName'},
        {text: '下单用户', value: 'userNickName'},
        {text: '处理状态', value: 'statusDesc'},
        {text: '订单号', value: 'orderId'},
        {text: '询价单号', value: 'inquiryId'},
        {text: '添加时间', value: 'createTimeStr'},
        {text: '处理人', value: 'operator'},
      ],
    };
  },
  methods: {
    openDialog(row) {
      // 设置当前选中的行数据，显示人工纠错弹窗
      this.currentFormData = {...row};
      this.dialogVisible = true;
    },
    openRemoveDialog(row) {
      // 设置当前要移除的订单，并打开移除订单弹窗
      this.selectedOrder = row;
      this.removeDialogVisible = true;
    },
    handleRemoveOrder(reason) {
      // 处理移除订单逻辑，例如发送请求并传递移除理由
      console.log('移除订单:', this.selectedOrder);
      console.log('移除理由:', reason);
      // 在这里可以调用 API，传递 selectedOrder 和 reason
      this.$message.success('订单已成功移除');
      this.removeDialogVisible = false;
      this.selectedOrder = null;
    },
    refreshTableData() {
      // 通知外部组件刷新数据
      this.$emit('refreshData');
    },
    indexMethod(index) {
      return index + 1;
    },
    copyTaobaoInquiryId(inquiryId) {
      // 创建一个临时的 textarea 用于复制文本
      const tempInput = document.createElement('textarea');
      tempInput.value = inquiryId;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('询价订单号已复制');
    },
    copyTaobaoOrderId(tbOrderId) {
      // 创建一个临时的 textarea 用于复制文本
      const tempInput = document.createElement('textarea');
      tempInput.value = tbOrderId;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('淘宝订单号已复制');
    },
    copyOrderId(tbOrderId) {
      // 创建一个临时的 textarea 用于复制文本
      const tempInput = document.createElement('textarea');
      tempInput.value = tbOrderId;
      document.body.appendChild(tempInput);
      tempInput.select();
      document.execCommand('copy');
      document.body.removeChild(tempInput);
      this.$message.success('订单号已复制');
    }
  },
};
</script>

<style scoped>
.look {
  color: blue;
  cursor: pointer;
  margin-right: 10px;
}

.delete {
  color: red;
  cursor: pointer;
}

.copy {
  cursor: pointer;
  color: #409EFF;
}
</style>



// WEBPACK FOOTER //
// src/views/pc/bypassAccountOrder/components/taobaoOrderErrorTable.vue